<template>
  <div
    :class="`document-field document-field--${currentField.type} ` + isForCurrentParty + isActive"
    :style="`width: ${currentField.width}%; height: ${currentField.height}%; top: ${currentField.y}%; left: ${currentField.x}%;color: ${currentField.color}`"
    :data-id="currentField.id"
    @click.self="openFieldPopup"
    @keypress.enter="openFieldPopup"
    v-if="currentField.type !== 'checkbox'"
    :tabindex="!isForCurrentParty ? '0' : ''">
    <div class="document-field__label" v-if="currentField.required === 'true' && !isDisabled && !prefilled">
      <icon name="asterisk" height="10" width="10"></icon>
    </div>
    <template v-if="currentField.type == 'signature'">
      <template v-if="isSignatureImage">
        <img :src="`${s3URL}/signatures/${signature}`" v-if="isURL" />
        <img :src="signature" v-else-if="isBase64" />
      </template>
      <template v-else-if="signature != null && signature != ''">
        <span>{{ currentField.content }}</span>
      </template>
      <template v-else-if="isForCurrentParty && !isDisabled">
        <span class="no-font">{{ $t('documentField.clickToAddSignature') }}</span>
      </template>
    </template>
    <template v-if="currentField.type == 'text'">
      <fit-text :changed="changedFontSize">{{ currentField.content }}</fit-text>
    </template>
    <template v-if="currentField.type == 'textarea'">
      <span>{{ currentField.content }}</span>
    </template>
    <template v-if="currentField.type == 'date'">
      <fit-text :changed="changedFontSize">{{ currentField.content }}</fit-text>
    </template>
    <template v-if="currentField.type == 'upload'">
      <span v-if="!isDisabled">{{ (currentField.upload && currentField.upload.length) ? $t('documentField.filesHaveBeenUploaded') : $t('documentField.uploadYourFiles') }}</span>
    </template>
    <template v-if="currentField.type == 'dropdown'">
      <fit-text :changed="changedFontSize">{{ currentField.content }}</fit-text>
      <icon class="dropdown-icon" name="caret-down" height="12" widt="12"></icon>
    </template>
  </div>
  <div
    :class="`document-field document-field--${currentField.type}${highlight ? ' document-field--highlighted' : ''}` + isForCurrentParty"
    :style="`width: ${currentField.width}%; height: ${currentField.height}%; top: ${currentField.y}%; left: ${currentField.x}%;`"
    :data-id="currentField.id"
    v-else>
      <div class="document-field__label document-field__label--checkbox" v-if="currentField.required === 'true' && !isDisabled">
        <icon name="asterisk" height="6" width="6"></icon>
      </div>
      <form-input :type="currentField.type" :name="currentField.group" :id="currentField.id" :is-disabled="isDisabled" :onSelect="selectCheckbox"></form-input>
    </div>
</template>

<script>

import FormInput from '@/components/FormInput'
import FitText from '@/components/FitText'

export default {
  name: 'document-field',
  props: [
    'fieldId',
    'fieldIndex'
  ],
  components: {
    FormInput,
    FitText
  },
  data () {
    return {
      signature: null,
      highlight: false,
      dropdownChoice: null,
      prefilled: false
    }
  },
  created () {
    if (this.currentField.type === 'signature') {
      this.setFieldSignature()
    }
    this.$bus.$on('highlightField', ({ field }) => {
      if (parseInt(this.currentField.id, 10) === parseInt(this.fieldId, 10)) {
        this.highlight = true
        setTimeout(() => {
          this.highlight = false
        }, 500)
      }
    })
    if (this.currentField.is_merge_field && this.currentField.content) this.prefilled = true
  },
  updated () {
    if (this.currentField.type === 'signature') {
      this.setFieldSignature()
    }
  },
  computed: {
    currentField () {
      return this.$store.getters.getField(this.fieldId, false)
    },
    // Used to generate dynamic class name. TODO Refactor
    isForCurrentParty () {
      const isForCurrentParty = this.currentField.party_id === this.$store.getters.currentPartyId
      if (!isForCurrentParty || this.prefilled) {
        return ' is-disabled'
      }
      return ''
    },
    isActive () {
      if (this.$store.state.activeFieldId === this.fieldId) return ' document-field--active'
      return ''
    },
    isSignatureImage () {
      return this.isURL || this.isBase64
    },
    isURL () {
      if (!this.signature) return false
      return this.signature.indexOf('.png') !== -1 || this.signature.indexOf('.jpg') !== -1 || this.signature.indexOf('.jpeg') !== -1
    },
    isBase64 () {
      if (!this.signature) return false
      return this.signature.indexOf('data:image') !== -1
    },
    isDisabled () {
      return this.currentField.party_id !== this.$store.getters.currentPartyId
    },
    s3URL () {
      return process.env.VUE_APP_AWS_S3_URL
    }
  },
  methods: {
    openFieldPopup (event) {
      const currentPartyId = this.$store.getters.currentPartyId
      const viewportmeta = document.querySelector('meta[name=viewport]')
      viewportmeta.setAttribute('content', 'width=device-width, initial-scale=1')
      if (this.currentField.party_id === currentPartyId && !(this.currentField.merge_field && this.currentField.prefilled && this.currentField.content)) {
        this.$store.commit('setActiveField', { activeFieldId: this.currentField.id })
      }
    },
    isJSON (str) { // TODO This may be dead code
      try {
        JSON.parse(str)
        return true
      } catch (e) {
        return false
      }
    },
    changedFontSize ({ fontSize }) {
      this.$store.dispatch('setCurrentFieldVal', {
        val: fontSize,
        id: this.currentField.id,
        property: 'font_size'
      })
    },
    setFieldSignature () {
      const signatureField = this.$store.getters.getField(this.currentField.id, false)
      if (signatureField.drawn_json) {
        if (typeof signatureField.drawn_json === 'string') {
          this.signature = JSON.parse(signatureField.drawn_json)[1]
        } else {
          this.signature = signatureField.drawn_json[1]
        }
      } else if (signatureField.upload && signatureField.upload !== '') {
        this.signature = signatureField.upload
      } else {
        this.signature = signatureField.content
      }
    },
    selectCheckbox () {
      const currentField = this.$store.getters.getField(this.currentField.id, false)
      if (currentField.group !== '') {
        const allFields = this.$store.getters.allFields
        allFields.forEach((field) => {
          if (field.id !== currentField.id && field.group === currentField.group) {
            this.$store.dispatch('setCurrentFieldVal', {
              id: field.id,
              val: '0',
              property: 'content'
            })
          }
        })
      }
      this.$store.dispatch('setCurrentFieldVal', {
        id: this.currentField.id,
        val: currentField.content === '1' ? '0' : '1',
        property: 'content'
      })
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  $color-signature-input: #9ccc31
  $color-text-input: #CCC
  $color-date-input: #39B7CD
  .document-field
    position: absolute
    padding: $spacing-xs
    border: 2px solid
    background-color: #fff
    cursor: pointer
    border-radius: 3px
    &--active
      box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.2)
    &--signature
      border-color: $color-signature-input
      > span:not(.no-font)
        font-family: 'danielregular'
    &--date
      border-color: $color-date-input
    &--text
      border-color: $color-text-input
      white-space: pre
    &--textarea
      overflow: inherit
      white-space: pre-line
      &.is-disabled
        pointer-events: initial!important
    &--checkbox
      padding: 0
      min-height: 15px !important
      min-width: 15px !important
      border: 0
      transition: all .5s ease
      &.is-disabled .checkbox
        background-color: transparent
        border: 0
        background-color: transparent
        padding: 0
        box-shadow: none
        svg
          color: black
    &--upload
      border-color: #395DCD
    &--dropdown
      border-color: #555
      transition: all .5s ease
      &.is-disabled
        svg
          display: none
      svg.dropdown-icon
        position: absolute
        transform: translate3d(0, -50%, 0)
        top: 50%
        right: $spacing-xs
        pointer-events: none
        margin-right: 0
    &--highlighted
      box-shadow: 0px 0px 0px 10px $color-main-dark
      transition: all .5s ease
      border-radius: 10px
    &.is-disabled
      border: 0
      background-color: transparent
      padding: 0
      cursor: default
      pointer-events: none
    img
      pointer-events: none
      position: absolute
      transform: translate3d(0, -50%, 0)
      top: 50%
      max-height: 100%
      max-width: 100%
      width: auto
    > span
      position: absolute
      top: 50%
      transform: translate3d(0, -50%, 0)
      pointer-events: none
      font-size: 12px
    &__label
      position: absolute
      background: $color-cancel
      top: -3px
      right: -3px
      color: #fff
      line-height: 0
      padding: 1px
      border-radius: 10px
      right: -7px
      top: -7px
      pointer-events: none
      svg
        margin: 0
      &--checkbox
        border-radius: 10px
  // Responsive
  @media screen and (max-width: $screen-size-large)
    .document-field,
    .document-field select
      min-height: auto
  @media screen and (max-width: $screen-size-medium)
    .document-field
      > span
        font-size: 8px
      &__label
        display: none
    .document-field select
      font-size: 8px
  @media screen and (max-width: $screen-size-small)
    .document-field
      > span
        font-size: 8px
    .document-field select
      font-size: 8px
      padding-left: 2px
  @media screen and (max-width: $screen-size-xs)
    .document-field
      white-space: normal
      > span
        font-size: 8px !important
    .document-field select
      font-size: 8px
      padding-left: 2px
</style>
